import { useMemo } from "react";
import dagre from "dagre";
import type { Node, Edge } from "@xyflow/react";
import type { CalculationNodeData } from "./graphUtils";

const NODE_WIDTH = 220;
const NODE_HEIGHT = 80;

export function useGraphLayout(
  nodes: Node<CalculationNodeData>[],
  edges: Edge[],
): { nodes: Node<CalculationNodeData>[]; edges: Edge[] } {
  return useMemo(() => {
    if (nodes.length === 0) return { nodes: [], edges: [] };

    const g = new dagre.graphlib.Graph();
    g.setDefaultEdgeLabel(() => ({}));
    g.setGraph({ rankdir: "TB", ranksep: 80, nodesep: 40 });

    for (const node of nodes) {
      g.setNode(node.id, { width: NODE_WIDTH, height: NODE_HEIGHT });
    }

    for (const edge of edges) {
      g.setEdge(edge.source, edge.target);
    }

    dagre.layout(g);

    const positionedNodes = nodes.map((node) => {
      const dagreNode = g.node(node.id);
      return {
        ...node,
        position: {
          x: dagreNode.x - NODE_WIDTH / 2,
          y: dagreNode.y - NODE_HEIGHT / 2,
        },
      };
    });

    return { nodes: positionedNodes, edges };
  }, [nodes, edges]);
}
